import { useLocation } from "react-router-dom";

export const isEnPath = (p) => p.startsWith("/en/");

export const useLang = () => {
  const en = isEnPath(useLocation().pathname);
  return { en, t: (fr, eng) => (en ? eng : fr) };
};

export const LANG_PAIRS = { "/devenir-revendeur": "/en/become-a-reseller", "/en/become-a-reseller": "/devenir-revendeur" };
